import { createRoot } from 'react-dom/client';
import App from './app.tsx';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { StrictMode } from 'react';
import { queryClient } from '@r/utils/utils.ts';
import { Toaster } from '@ui/sonner.tsx';
import * as Sentry from '@sentry/react';
import { isProd } from '@r/utils/utils.ts';
import { HelmetProvider } from 'react-helmet-async';
import { ServerErrorProvider } from '@r/context/server-error-provider.tsx';

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: isProd()
    ? 'https://cdb37d466df4463cc297b69b78178399@o158705.ingest.us.sentry.io/4508444540993536'
    : undefined,
  integrations: []
});

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ServerErrorProvider>
          <App />
          <ReactQueryDevtools initialIsOpen={false} />
          <Toaster />{' '}
        </ServerErrorProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>
);
